import React from "react"

// Simple utility to combine classes
const cn = (...inputs: (string | undefined | null | false)[]): string => {
  return inputs.filter(Boolean).join(" ")
}

// Manual variant system for badges
const getVariantClasses = (variant?: string): string => {
  const baseClasses = "badge"

  const variantClasses = {
    primary: "badge-primary",
    pending: "badge-pending",
    generating: "badge-generating",
    completed: "badge-completed",
    failed: "badge-failed",
    warning: "bg-warning",
  }

  const variantClass =
    variantClasses[variant as keyof typeof variantClasses] || "badge-primary"

  return cn(baseClasses, variantClass)
}

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode
  variant?:
    | "primary"
    | "pending"
    | "generating"
    | "completed"
    | "failed"
    | "warning"
  pulse?: boolean
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    { className, variant = "primary", pulse = false, children, ...props },
    ref,
  ) => {
    const badgeClasses = getVariantClasses(variant)

    return (
      <span
        className={cn(
          "component-ui-badge",
          badgeClasses,
          pulse && "badge-pulse",
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </span>
    )
  },
)

Badge.displayName = "Badge"

export { Badge }
